import { setObjectTypesRo } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import { MultiselectFilter } from './MultiselectFilter';
import { useObjectTypeOptions } from './ObjectTypesFilter';

export const ObjectTypesRoFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();

  return (
    <MultiselectFilter<number>
      filterName="objectTypesRo"
      label={label ?? t('ObjectType')}
      action={setObjectTypesRo}
      elementRef={elementRef}
      useItemsHook={useObjectTypeOptions}
    />
  );
};

export default ObjectTypesRoFilter;
